"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_cookie_1 = require("react-cookie");
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../hooks");
var CookiesBanner_1 = __importDefault(require("../../pages/PristupnostCookies/CookiesBanner"));
var CacheProvider_1 = require("../../providers/CacheProvider");
var ConfigProvider_1 = require("../../providers/ConfigProvider");
var promise_1 = require("../../utils/promise");
var utils_1 = require("../../utils/utils");
var Footer_1 = require("../Footer/Footer");
var getBarvaProstredi = function (prostrediTyp) {
    if (prostrediTyp === undefined)
        return undefined;
    switch (prostrediTyp) {
        case 'VP':
            return 'darkblue';
        case 'TP1':
            return 'darkred';
        case 'TP2':
            return 'darkgreen';
        default:
            return 'silver';
    }
};
var Content = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1 0 auto;\n"], ["\n  flex: 1 0 auto;\n"])));
var Body = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n"])));
var Rows = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n"])));
var Edge = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  width: 25px;\n  padding: 3px;\n  writing-mode: vertical-rl;\n  font-weight: bold;\n  text-align: center;\n  text-align-last: justify;\n  color: black;\n  overflow-x: hidden;\n"], ["\n  ",
    "\n  width: 25px;\n  padding: 3px;\n  writing-mode: vertical-rl;\n  font-weight: bold;\n  text-align: center;\n  text-align-last: justify;\n  color: black;\n  overflow-x: hidden;\n"])), function (_a) {
    var $barvaProstredi = _a.$barvaProstredi;
    return $barvaProstredi && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), $barvaProstredi);
});
var Text = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  word-spacing: 30px;\n  color: white;\n  mix-blend-mode: difference;\n"], ["\n  word-spacing: 30px;\n  color: white;\n  mix-blend-mode: difference;\n"])));
var Layout = function (_a) {
    var _b;
    var children = _a.children, jumpToMenu = _a.jumpToMenu;
    var cache = CacheProvider_1.useCache();
    var _c = react_1.useState(), version = _c[0], setVersion = _c[1];
    var _d = react_1.useState(), barvaProstredi = _d[0], setBarvaProstredi = _d[1];
    var _e = react_1.useState(), prostredi = _e[0], setProstredi = _e[1];
    var googleAnalytics = ConfigProvider_1.useConfig().googleAnalytics;
    var cookies = react_cookie_1.useCookies(['cookiesEnabled'])[0];
    var token = hooks_1.useToken();
    var history = react_router_dom_1.useHistory();
    react_1.useEffect(function () {
        var handleToken = function (e) {
            if (e.key === 'token' && ((e.oldValue && !e.newValue) || (!e.oldValue && e.newValue))) {
                window.location.reload();
            }
        };
        window.addEventListener('storage', handleToken);
        return function () {
            window.removeEventListener('storage', handleToken);
        };
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (googleAnalytics && ((_a = cookies === null || cookies === void 0 ? void 0 : cookies.cookiesEnabled) === null || _a === void 0 ? void 0 : _a.analyticke)) {
            var comment = document.createComment('Global Site Tag (gtag.js) - Google Analytics');
            var script = document.createElement('script');
            var configScript = document.createElement('script');
            script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-0PRKH1RYSP');
            configScript.append('window.dataLayer = window.dataLayer || [];');
            configScript.append('function gtag(){dataLayer.push(arguments);}');
            configScript.append("gtag('js', new Date());");
            configScript.append("gtag('config', 'G-0PRKH1RYSP');");
            document.getElementsByTagName('head')[0].appendChild(comment);
            document.getElementsByTagName('head')[0].appendChild(script);
            document.getElementsByTagName('head')[0].appendChild(configScript);
        }
    }, [googleAnalytics, (_b = cookies === null || cookies === void 0 ? void 0 : cookies.cookiesEnabled) === null || _b === void 0 ? void 0 : _b.analyticke]);
    react_1.useEffect(function () {
        var fetchVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
            var cacheHit, response, jsonConfig, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        cacheHit = cache === null || cache === void 0 ? void 0 : cache.read('version.json');
                        if (cacheHit) {
                            return [2 /*return*/, setVersion(cacheHit.APP_VERSION)];
                        }
                        return [4 /*yield*/, Promise.race([fetch(utils_1.UriKontext() + "/version.json"), promise_1.timeoutRejection()])];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        jsonConfig = _a.sent();
                        if (cache) {
                            cache.write('version.json', jsonConfig);
                        }
                        setVersion(jsonConfig.APP_VERSION);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error('Failed do load version.json file');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchVersion();
        var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
            var cacheHit, response, jsonConfig, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        cacheHit = cache === null || cache === void 0 ? void 0 : cache.read('appConfig.json');
                        if (cacheHit) {
                            setProstredi(cacheHit.PROSTREDI);
                            return [2 /*return*/, setBarvaProstredi(getBarvaProstredi(cacheHit.PROSTREDI))];
                        }
                        return [4 /*yield*/, Promise.race([fetch(utils_1.UriKontext() + "/appConfig.json"), promise_1.timeoutRejection()])];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        jsonConfig = _a.sent();
                        if (cache) {
                            cache.write('appConfig.json', jsonConfig);
                        }
                        setProstredi(jsonConfig.PROSTREDI);
                        setBarvaProstredi(getBarvaProstredi(jsonConfig.PROSTREDI));
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.error('Failed do load appConfig.json file');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchConfig();
    }, []);
    if (prostredi !== undefined) {
        var text = '';
        for (var x = 0; x < 35; x += 1) {
            text = text.concat(prostredi, ' ');
        }
        return (react_1.default.createElement(Rows, null,
            react_1.default.createElement(Edge, { "$barvaProstredi": barvaProstredi },
                react_1.default.createElement(Text, null, text)),
            react_1.default.createElement(Body, null,
                react_1.default.createElement(Content, null, children),
                version && react_1.default.createElement(Footer_1.Footer, { version: version, jumpToMenu: jumpToMenu }),
                react_1.default.createElement(CookiesBanner_1.default, null)),
            react_1.default.createElement(Edge, { "$barvaProstredi": barvaProstredi },
                react_1.default.createElement(Text, null, text))));
    }
    return (react_1.default.createElement(Body, null,
        react_1.default.createElement(Content, null, children),
        version && react_1.default.createElement(Footer_1.Footer, { version: version, jumpToMenu: jumpToMenu }),
        react_1.default.createElement(CookiesBanner_1.default, null)));
};
exports.default = Layout;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
